theme.footerSection = (function () {
  "use strict";

  var MOBILE_BREAKPOINT = 750;

  function getFooterWidgets(footer) {
    if (!footer) return [];

    return footer.querySelectorAll(".footer__widget");
  }

  function getWidgetInner(widget) {
    if (!widget) return null;

    return widget.querySelector(".footer__widget_inner");
  }

  function getWidgetToggle(widget) {
    if (!widget) return null;

    return widget.querySelector(".footer__widget_toggle");
  }


  /* =======================================================
     MOBILE NAVIGATION BAR HEIGHT
  ======================================================= */

  function updateMobileNavigationHeight() {
    var mobileNavigationBar = document.querySelector(
      ".mobile__navigation--bar"
    );

    if (!mobileNavigationBar) return;

    document.documentElement.style.setProperty(
      "--mobile-navigation-bar-height",
      mobileNavigationBar.clientHeight + "px"
    );
  }


  function setupMobileNavigationHeight() {
    var mobileNavigationBar = document.querySelector(
      ".mobile__navigation--bar"
    );

    if (!mobileNavigationBar) return;

    updateMobileNavigationHeight();

    if (
      mobileNavigationBar.getAttribute(
        "data-footer-height-listener"
      ) === "true"
    ) {
      return;
    }

    mobileNavigationBar.setAttribute(
      "data-footer-height-listener",
      "true"
    );

    window.addEventListener(
      "resize",
      updateMobileNavigationHeight
    );
  }


  /* =======================================================
     CLOSE WIDGET
  ======================================================= */

  function closeWidget(widget, animate) {
    if (!widget) return;

    var inner = getWidgetInner(widget);
    var toggle = getWidgetToggle(widget);

    widget.classList.remove("active");

    if (toggle) {
      toggle.setAttribute(
        "aria-expanded",
        "false"
      );
    }

    if (!inner) return;


    /*
     * Use theme slide animation when available.
     */

    if (
      animate &&
      typeof slideUp === "function"
    ) {
      slideUp(inner);

      return;
    }


    /*
     * Fallback if theme slideUp function
     * is not available.
     */

    if (
      window.innerWidth <
      MOBILE_BREAKPOINT
    ) {
      inner.style.display = "none";
    } else {
      inner.style.display = "";
    }
  }


  /* =======================================================
     OPEN WIDGET
  ======================================================= */

  function openWidget(widget, animate) {
    if (!widget) return;

    var inner = getWidgetInner(widget);
    var toggle = getWidgetToggle(widget);

    widget.classList.add("active");

    if (toggle) {
      toggle.setAttribute(
        "aria-expanded",
        "true"
      );
    }

    if (!inner) return;


    /*
     * Use theme slide animation when available.
     */

    if (
      animate &&
      typeof slideDown === "function"
    ) {
      slideDown(inner);

      return;
    }


    /*
     * Fallback.
     */

    inner.style.display = "block";
  }


  /* =======================================================
     CLOSE OTHER FOOTER WIDGETS
  ======================================================= */

  function closeOtherWidgets(
    footer,
    currentWidget
  ) {
    var widgets = getFooterWidgets(
      footer
    );

    widgets.forEach(
      function (widget) {

        if (
          widget !==
          currentWidget
        ) {
          closeWidget(
            widget,
            true
          );
        }

      }
    );
  }


  /* =======================================================
     DESKTOP RESET
  ======================================================= */

  function resetDesktopFooter(
    footer
  ) {
    var widgets = getFooterWidgets(
      footer
    );

    widgets.forEach(
      function (widget) {

        var inner =
          getWidgetInner(
            widget
          );

        var toggle =
          getWidgetToggle(
            widget
          );


        widget.classList.remove(
          "active"
        );


        if (inner) {
          inner.style.display = "";
        }


        if (toggle) {
          toggle.setAttribute(
            "aria-expanded",
            "false"
          );
        }

      }
    );
  }


  /* =======================================================
     MOBILE RESET
  ======================================================= */

  function resetMobileFooter(
    footer
  ) {
    var widgets = getFooterWidgets(
      footer
    );

    widgets.forEach(
      function (widget) {

        var inner =
          getWidgetInner(
            widget
          );

        var toggle =
          getWidgetToggle(
            widget
          );


        widget.classList.remove(
          "active"
        );


        if (inner) {

          /*
           * Remove any inline desktop value.
           * footer.css will hide the content.
           */

          inner.style.display = "";

        }


        if (toggle) {

          toggle.setAttribute(
            "aria-expanded",
            "false"
          );

        }

      }
    );
  }


  /* =======================================================
     RESPONSIVE STATE
  ======================================================= */

  function updateFooterState(
    footer
  ) {

    if (
      window.innerWidth >=
      MOBILE_BREAKPOINT
    ) {

      resetDesktopFooter(
        footer
      );

    } else {

      resetMobileFooter(
        footer
      );

    }

  }


  /* =======================================================
     ACCORDION
  ======================================================= */

  function setupAccordion(
    footer
  ) {

    if (!footer) return;


    /*
     * Prevent duplicate event listeners.
     */

    if (
      footer.getAttribute(
        "data-footer-accordion-ready"
      ) === "true"
    ) {
      return;
    }


    footer.setAttribute(
      "data-footer-accordion-ready",
      "true"
    );


    var toggles =
      footer.querySelectorAll(
        ".footer__widget_toggle"
      );


    toggles.forEach(
      function (toggle) {

        toggle.setAttribute(
          "aria-expanded",
          "false"
        );


        toggle.addEventListener(
          "click",
          function (event) {

            /*
             * Accordion only on mobile.
             */

            if (
              window.innerWidth >=
              MOBILE_BREAKPOINT
            ) {
              return;
            }


            event.preventDefault();


            var widget =
              toggle.closest(
                ".footer__widget"
              );


            if (!widget) return;


            /*
             * Close clicked item.
             */

            if (
              widget.classList.contains(
                "active"
              )
            ) {

              closeWidget(
                widget,
                true
              );

            } else {

              /*
               * Close all other footer items first.
               */

              closeOtherWidgets(
                footer,
                widget
              );


              /*
               * Open selected item.
               */

              openWidget(
                widget,
                true
              );

            }

          }
        );

      }
    );


    updateFooterState(
      footer
    );
  }


  /* =======================================================
     RESIZE
  ======================================================= */

  function setupResize(
    footer
  ) {

    if (!footer) return;


    if (
      footer.getAttribute(
        "data-footer-resize-ready"
      ) === "true"
    ) {
      return;
    }


    footer.setAttribute(
      "data-footer-resize-ready",
      "true"
    );


    var wasDesktop =
      window.innerWidth >=
      MOBILE_BREAKPOINT;


    window.addEventListener(
      "resize",
      function () {

        var isDesktop =
          window.innerWidth >=
          MOBILE_BREAKPOINT;


        /*
         * Only reset when crossing
         * mobile / desktop breakpoint.
         */

        if (
          isDesktop !==
          wasDesktop
        ) {

          updateFooterState(
            footer
          );

          wasDesktop =
            isDesktop;

        }

      }
    );
  }


  /* =======================================================
     INITIALIZE ONE FOOTER
  ======================================================= */

  function initFooter(
    footer
  ) {

    if (!footer) return;


    setupAccordion(
      footer
    );


    setupResize(
      footer
    );

  }


  /* =======================================================
     MAIN THEME FUNCTION
  ======================================================= */

  function footer() {

    setupMobileNavigationHeight();


    var footers =
      document.querySelectorAll(
        '.footer[data-section-type="footer"]'
      );


    footers.forEach(
      function (footerElement) {

        initFooter(
          footerElement
        );

      }
    );

  }


  /* =======================================================
     SHOPIFY THEME EDITOR SUPPORT
  ======================================================= */

  document.addEventListener(
    "shopify:section:load",
    function (event) {

      var section =
        event.target;


      if (!section) return;


      var footerElement =
        null;


      /*
       * Section itself is footer.
       */

      if (
        section.matches &&
        section.matches(
          '.footer[data-section-type="footer"]'
        )
      ) {

        footerElement =
          section;

      }


      /*
       * Or footer exists inside
       * Shopify section wrapper.
       */

      else if (
        section.querySelector
      ) {

        footerElement =
          section.querySelector(
            '.footer[data-section-type="footer"]'
          );

      }


      if (
        footerElement
      ) {

        initFooter(
          footerElement
        );


        setupMobileNavigationHeight();

      }

    }
  );


  return footer;

})();